<template>
  <section>
    <UserRoleChangedModal :permissionsData="permissionsData"/>
    <OwnerUpdateModal v-if="ownerUpdatedData" :eventData="ownerUpdatedData"/>
    <endSessionWithDiffAdminModal :sessionId="sessionId" :sessionName="sessionName" :diffAdminEndSessionName="diffAdminEndSession" />
    <startSessionWithDiffAdminModal :sessionId="sessionId" :sessionName="sessionName" :diffAdminEndSessionName="diffAdminEndSession" />
    <EntitySubscriptionModal :actionType="actionType" :entityPlan="entityPlan"/>
    <EntityPlanModal :entityPlan="entityPlan"/>
    <OtpAuthAppliedMessage/>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserRoleChangedModal from "@/components/users/UserRoleChangedModal";
import OwnerUpdateModal from "@/components/users/OwnerUpdateModal";
import EntitySubscriptionModal from "@/components/entity/EntitySubscriptionModal";
import EntityPlanModal from "@/components/entity/EntityPlanModal";
import endSessionWithDiffAdminModal from "@/components/emergency/endSessionWithDiffAdminModal";
import startSessionWithDiffAdminModal from "@/components/emergency/startSessionWithDiffAdminModal";
import OtpAuthAppliedMessage from "@/components/entity/OtpAuthAppliedMessage";

export default {
  name: "webSocketEvents",
  data() {
    return {
      entityPlan: null,
      actionType: null,
      diffAdminEndSession: '',
      sessionId: null,
      sessionName: null,
      permissionsData: null,
      ownerUpdatedData: null,
      gridData: [] // Stores real-time updated grid data
    };
  },
  components: {
    UserRoleChangedModal,
    endSessionWithDiffAdminModal,
    startSessionWithDiffAdminModal,
    OwnerUpdateModal,
    EntitySubscriptionModal,
    EntityPlanModal,
    OtpAuthAppliedMessage,
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity", "userDetails"]),
    userEmail() {
      return this.userDetails?.email;
    },
    isEntityOwner() {
      return this.userDetails?.user_id === this.currentEntity?.owner_id;
    }
  },
  methods: {
    ...mapActions("authfack", [
      "updateUserRoleAfterChange",
      "fetchSocketDataToRefreshGrid",
      "updateEntityPackage",
      "updateEntityPlan",
      "logout"
    ]),
    ...mapActions("emergency", [
      "fetchSessionData",
      "fetchAreasWithSession",
      "fetchGridEmergencySessionsListData",
      "fetchIfHavePermissionWithSession"
    ]),
    ...mapActions("authfack", ["setCurrentEntity"]),

    // ✅ Efficiently Update a Specific Row Instead of Refreshing the Grid
    updateRowData(updatedRow) {
      const index = this.gridData.findIndex(row => row.id === updatedRow.id);
      if (index !== -1) {
        this.gridData[index] = { ...updatedRow };
      } else {
        this.gridData.push(updatedRow);
      }
      this.gridData = [...this.gridData]; // Ensures reactivity
    }
  },

  created() {
    console.log("Socket connected: ", this.$socket.connected);
    this.$socket.emit("join", { entity: this.currentEntity.id });
  },

  sockets: {
    connect() {
      console.log("WebSocket connected.");
    },

    disconnect() {
      console.log("WebSocket disconnected. Reconnecting...");
      setTimeout(() => {
        this.$socket.connect();
      }, 3000);
    },

    update(data) {
      // if (data) {
      //   this.updateRowData(data);
      // }
      console.log("Real-time update received:", data);
      if(data.entity_user_id && data.entity_user_id == this.userDetails.id && data.permitted_by != this.userDetails.id){
        this.permissionsData = null;
        this.updateUserRoleAfterChange({
          params : {
            entity_id : this.currentEntity.id,
            user_id : this.userDetails.user_id,
          }
        }).then( async (res)=>{
          // console.log('ressss',res);
          this.permissionsData = {
            sites : res.data.siteNames,
            userTypes : res.data.userTypeNames,
          }
          // console.log("permissionsData", this.permissionsData);
          setTimeout(()=>{
            this.$bvModal.show("changeRoleByDiffAdminModal");
          },400)
        });
      }
    },
    updateEmergencySessionData(data) {
      console.log("updateEmergencySessionData row", data);
      this.fetchSessionData({ 
        id: data.session, 
        params : {
          sites : [],
          areas : [],
        } 
      });
    },
    async pongUpdateEntityPackage(data) {
      console.log("pongUpdateEntityPackage received:", data);
      if (!data.entityPlan) return;

      this.actionType = data.action;
      this.entityPlan = data.entityPlan;

      if (this.entityPlan !== this.currentEntity.plan) {
        await this.updateEntityPlan(data.entityPlan);
        if (this.userEmail !== "lt_techteam@visipoint.com") {
          this.$bvModal.show("EntitySubscriptionModal");
        }
      }
    },

    async pongUpdateEntityPlan(data) {
      console.log("pongUpdateEntityPlan received:", data);
      if (!data.entityPlan) return;

      this.entityPlan = data.entityPlan;
      await this.updateEntityPlan(data.entityPlan);

      if (this.userEmail !== "lt_techteam@visipoint.com") {
        this.$bvModal.show("EntityPlanModal");
      }
    },

    async pongUpdateUserRole(data) {
      console.log("pongUpdateUserRole received:", data);
      if (!data.data || data.data.user_id !== this.userDetails.user_id) return;

      this.permissionsData = null;
      await this.updateUserRoleAfterChange({
        params: {
          entity_id: data.data.entity,
          user_id: data.data.user_id
        }
      }).then(res => {
        this.permissionsData = {
          oldRole: data.data.oldRole,
          newRole: data.data.newRole,
          sites: res.data.siteNames,
          userTypes: res.data.userTypeNames
        };
        setTimeout(() => {
          this.$bvModal.show("changeRoleByDiffAdminModal");
        }, 500);
      });
    },

    async pongStartSessionDiffAdmin(data) {
      console.log("pongStartSessionDiffAdmin received:", data);
      if (data.data.user.email === this.userEmail) return;

      await this.fetchSessionData({ id: data.data.sessionId,  
        params : {
          sites : [],
          areas : [],
        }
      });
      this.fetchIfHavePermissionWithSession(data.data.sessionId).then(res => {
        if (res?.data) {
          this.diffAdminEndSession = data.data.user.fullName;
          this.sessionId = data.data.sessionId;
          this.sessionName = data.data.sessionName;
          this.$bvModal.show("startSessionWithDiffAdminModal");
          this.fetchAreasWithSession();
          this.fetchGridEmergencySessionsListData();
        }
      });
    },

    async pongEndSessionDiffAdmin(data) {
      console.log("pongEndSessionDiffAdmin received:", data);
      if (data.data.userIdEnded === this.userDetails.user_id) return;

      await this.fetchSessionData({ id: data.data.sessionId,
        params : {
          sites : [],
          areas : [],
       }
      });
      this.fetchIfHavePermissionWithSession(data.data.sessionId).then(res => {
        if (res?.data) {
          this.diffAdminEndSession = data.data.userName;
          this.sessionId = data.data.sessionId;
          this.sessionName = data.data.sessionName;
          this.$bvModal.show("endSessionWithDiffAdminModal");
          this.fetchAreasWithSession();
          this.fetchGridEmergencySessionsListData();
        }
      });
    },

    async updateEntityTwoStepAuth(data) {
      console.log("updateEntityTwoStepAuth received:", data);
      await this.fetchActiveSessionsData().then(async (sessionData) => {
        await this.setCurrentEntity(sessionData.data.entity);
      });

      if (data.data.entity_id === this.currentEntity.id &&
          data.data.updated_by !== this.userDetails.user_id &&
          !this.userDetails.is_otp_enabled &&
          this.currentEntity.otp_roles.includes(this.userDetails.role_id) &&
          this.userEmail !== "lt_techteam@visipoint.com") {
        this.$bvModal.show("OtpAuthAppliedMessageModal");
      }
    },

    updateUserTwoStepAuth(data) {
      console.log("updateUserTwoStepAuth received:", data);
      if (data.isOtpEnabled && data.user_id === this.userDetails.user_id) {
        this.logout();
      }
    }
  }
};
</script>
